<script>
export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    isParent: {
      type: Boolean,
      default: false,
    }
  },

  data () {
    return {
      duration: 0,
      playedTime: 0,
      isLoading: true,
      isHovered: false,
      isPlaying: false,
    };
  },

  mounted () {

  },

  computed: {
    remainingTime () {
      const remainingTime = this.duration - this.playedTime;

      const minutes = Math.floor(remainingTime / 60);
      const seconds = Math.floor(remainingTime % 60);

      const paddedSeconds = seconds.toString().padStart(2, '0');

      return `${minutes}:${paddedSeconds}`;
    }
  },

  methods: {
    toggleAudio () {
      const audioPlayer = this.$refs['audio-player'];

      if (this.isParent) {
        return;
      }

      if (!this.isPlaying) {
        audioPlayer.play();
        this.isPlaying = true;
      } else {
        audioPlayer.pause();
        this.isPlaying = false;
      }
    },

    handleCanPlay () {
      const audioPlayer = this.$refs['audio-player'];

      this.duration = audioPlayer.duration;

      this.isLoading = false;
    },

    handleTimeUpdated () {
      const audioPlayer = this.$refs['audio-player'];

      this.playedTime = audioPlayer.currentTime;
    },

    handleEnded () {
      this.isPlaying = false;
      this.playedTime = 0;
    }
  }
}
</script>

<template>
  <div
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
    class="attendence-message-audio"
    :class="{ 'is-parent': isParent }"
  >
    <button
      v-on:click="toggleAudio"
    >
    <IconPause v-if="isPlaying && !isParent" />
    <IconPlay v-else-if="isHovered && !isLoading && !isParent" />
    <IconMicrophone v-else />
    </button>
    <span>{{ remainingTime }}</span>
    <audio
      ref="audio-player"
      muted="muted"
      v-on:canplay="handleCanPlay"
      v-on:timeupdate="handleTimeUpdated"
      v-on:ended="handleEnded"
      :src="message.file.signedUrl"
    ></audio>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.attendence-message-audio {
  display: flex;
  align-self: flex-start;
  min-height: 36px;
  justify-content: center;
  gap: 8px;
  padding: 8px 24px;
  border: 1px solid $salesflow-outline-gray-medium;
  border-radius: 14px;
  @include salesflow-text($font-weight: 500, $line-height: 150%);

  &:hover {
    background-color: $salesflow-outline-gray-light;
  }

  button {
    padding: 0px;
    border: 0px;
    margin: 0px;
    outline: 0px;
    min-width: 8px;
    background-color: transparent;
    line-height: 0px;

    &:hover {
      cursor: pointer;
    }

    &:focus {
      outline: 0px;
    }
  }

  &.is-parent {
    &:hover {
      background-color: transparent;
    }

    button:hover {
      cursor: inherit;
    }
  }
}

</style>
